import React from 'react';

export const themes={
  dark:{
    color:"#fff",
    backgroundImage:"url(https://i.pinimg.com/originals/e1/6d/42/e16d4219e671bac00d1c23131e6d723f.jpg)",
    backgroundAttachment: "fixed",
  },
  light:{
    color: "#fff",
    backgroundImage:"url(https://www.designyourway.net/blog/wp-content/uploads/2019/02/aesthetic-wallpaper-1.jpg)",
    // height:"60%",
    // width:"100%",
    backgroundPosition: "center",
    // backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
  },
  dark1:{
    color:"#fff",
  },
  light1:{
    color: "#fff",
  }
}


const ThemeContext = React.createContext(themes.light);

export default ThemeContext;
